import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { useParams } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import PrintIcon from '@mui/icons-material/Print';

import ExercisePreviewHandler from '@ts-core/modules/exercises/components/ExercisePreviewHandler';

import { useAssignment } from '../../hooks';

const AssignmentExercisesPage = () => {
  const exercisesRef = useRef<any>();
  const { courseId, assignmentId } = useParams<{ courseId: string; assignmentId: string }>();
  const { loading, assignment } = useAssignment({ courseId, assignmentId });

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <div id="assignment-exercises">
      <Box display="flex" justifyContent="flex-end">
        <ReactToPrint
          trigger={() => (
            <IconButton size="large">
              <PrintIcon />
            </IconButton>
          )}
          content={() => exercisesRef.current}
        />
      </Box>

      <Box ref={exercisesRef}>
        {assignment?.exercises?.map((e) => (
          <ExercisePreviewHandler key={e.id} exercise={e} hideNoAnswerOption hideQuestionBackgroundColor hideScores />
        ))}
      </Box>
    </div>
  );
};

export default AssignmentExercisesPage;
